import axiosInstance from "@/api/axios-instance";
import { Region } from "../types/region";

export async function updateRegionStatus(id: string, is_active: boolean) {
  const response = await axiosInstance.patch<Region>(`/region/status/${id}`, {
    is_active,
  });
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update region status");
  }
  return response.data;
}
